import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { getUserLoans } from '../api/Index'
import LoanCard from '../components/member/LoanCard'
import PageTitle from '../components/UI/PageTitle'
import Separator from '../components/UI/Separator'

const UserLoans = () => {
  const navigate = useNavigate();
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserLoans = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getUserLoans();
        setLoans(response.data);
      } catch (err) {
        setError(err.message);
        console.error('Error fetching user loans:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserLoans();
  }, []);

  const handleLoanClick = (loanId) => {
    navigate(`/loan-details?id=${loanId}`);
  };

  if (loading) {
    return (
      <div>
        <PageTitle title='My Loans' />
        <div>Loading your loans...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageTitle title='My Loans' />
        <div style={{color: 'red'}}>Error: {error}</div>
      </div>
    );
  }

  return (
    <div>
        <PageTitle title='My Loans' />
        <div className='loans-profile-container'>
            {loans.length === 0 ? (
              <div>You have no loans yet.</div>
            ) : (
              loans.map((loan, index) => (
                <div key={loan._id || loan.id || index}>
                  <div onClick={() => handleLoanClick(loan._id || loan.id)} style={{cursor: 'pointer'}}>
                    <LoanCard {...loan} />
                  </div>
                  <Separator />
                </div>
              ))
            )}
        </div>
    </div>
  )
}

export default UserLoans